import { createStore } from 'vuex'

export default createStore({
  state: {
    compw: ''
  },
  getters: {
    // 將 any 改為具體定義或 Record
    getPw: function(state: Record<string, any>) {
      return state.compw;
    }
  },
  mutations: {
    // 將 object 改為 Record<string, any> 解決 ESLint 報錯
    insertPw: function(state: Record<string, any>, payload: any){
      state.compw = payload;
    }
  },
  actions: {
    // 補上 context 的類型定義，並將 payload 改為 any
    setPw: function(context: any, payload: any){
      context.commit("insertPw", payload);
    }
  },
  modules: {
  }
})